// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"19":"b4278a69","58":"5ba10872","226":"4813a6b8","399":"fd4d1f75","427":"7606b45f","505":"ea87eb58","576":"1899300a","660":"17af9551","681":"23d171a0","752":"5f901d03","875":"e4b2077a"}[chunkId] + ".chunk.js";
};